(function (scope) {
  'use strict';
  var ENGINE_ORIGIN = 'https://portrait-animaux.compagnonsdecoeur.fr';
  var SHOP_ORIGIN = 'https://compagnonsdecoeur.fr';
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  var TOKEN = /^[A-Za-z0-9_-]{43}$/;
  var SIGNATURE = /^[0-9a-f]{64}$/;
  var KEYS = ['Prénom à graver', 'Texte fixe', '_Configuration', '_cdc_creation_id', '_cdc_schema', '_cdc_signature'];

  function exact(data, keys) {
    return data && typeof data === 'object' && !Array.isArray(data) &&
      Object.keys(data).length === keys.length && keys.every(function (key) { return Object.prototype.hasOwnProperty.call(data, key); });
  }
  function validRequest(data) {
    return exact(data, ['type', 'protocolVersion', 'requestId', 'cartIntentToken']) &&
      data.type === 'cdc.personalization.cart.request' && data.protocolVersion === 1 &&
      typeof data.requestId === 'string' && UUID.test(data.requestId) &&
      typeof data.cartIntentToken === 'string' && TOKEN.test(data.cartIntentToken);
  }
  function validLine(data, requestId) {
    if (!exact(data, ['requestId', 'creationId', 'line']) || data.requestId !== requestId ||
        typeof data.creationId !== 'string' || !UUID.test(data.creationId) ||
        !exact(data.line, ['variantId', 'quantity', 'properties', 'observedShopifyPrice']) ||
        typeof data.line.variantId !== 'string' || !/^\d+$/.test(data.line.variantId) ||
        data.line.quantity !== 1 || !exact(data.line.properties, KEYS) ||
        data.line.properties._cdc_creation_id !== data.creationId ||
        data.line.properties._cdc_schema !== 'engraving-1' ||
        !SIGNATURE.test(data.line.properties._cdc_signature)) return false;
    return KEYS.every(function (key) { return typeof data.line.properties[key] === 'string' && data.line.properties[key].length > 0; });
  }
  function matchingItems(cart, line, creationId) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('cart_unavailable');
    return cart.items.filter(function (item) {
      return item && item.properties && item.properties._cdc_creation_id === creationId;
    }).map(function (item) {
      var valid = String(item.variant_id) === line.variantId && item.quantity === 1 &&
        KEYS.every(function (key) { return item.properties[key] === line.properties[key]; }) &&
        Object.keys(item.properties).length === KEYS.length;
      return { item: item, valid: valid };
    });
  }
  async function openNativeCart(win, cartData) {
    var nativeCart = win.theme && win.theme.Cart;
    if (!nativeCart || typeof nativeCart.setCurrentData !== 'function' ||
        typeof nativeCart.updateCart !== 'function' || typeof nativeCart.showPopup !== 'function' ||
        !nativeCart.$popup || !nativeCart.$popup.length || !win.theme.Popups ||
        typeof win.theme.Popups.callByName !== 'function' ||
        typeof win.theme.Popups.getByName !== 'function') return false;
    try {
      var popup = win.theme.Popups.getByName('cart');
      if (!popup || !popup.length) return false;
      nativeCart.setCurrentData(cartData);
      await nativeCart.updateCart();
      nativeCart.showPopup();
      return true;
    } catch (_) {
      return false;
    }
  }
  function createParentBridge(options) {
    var frame = options.frame;
    var win = options.window;
    var fetcher = options.fetch;
    var storage = options.storage;
    var engineOrigin = options.engineOrigin;
    var shopOrigin = options.shopOrigin;
    var productId = options.productId;
    var locale = options.locale;
    var onReady = options.onReady;
    var pending = false;
    var completed = new Set();
    var loaded = false;
    var ready = false;
    if (!frame || !win || !fetcher || !storage ||
        (engineOrigin !== ENGINE_ORIGIN && engineOrigin !== 'http://127.0.0.1:3008') ||
        (shopOrigin !== SHOP_ORIGIN && shopOrigin !== 'http://127.0.0.1:3008') ||
        !/^\d+$/.test(productId) || !/^[a-z]{2}(?:-[A-Z]{2})?$/.test(locale)) throw new Error('embed_unavailable');
    var root = win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/';
    var cartBase = root.replace(/\/$/, '') + '/cart';
    function send(data) { frame.contentWindow.postMessage(data, engineOrigin); }
    function context() {
      send({ type: 'cdc.personalization.parent.context', protocolVersion: 1,
        productId: productId, locale: locale, consent: 'unknown' });
    }
    function onLoad() {
      loaded = true;
      context();
      if (ready && onReady) onReady();
    }
    function result(requestId, creationId, status, code) {
      send(status === 'added' ? { type: 'cdc.personalization.cart.result', protocolVersion: 1,
        requestId: requestId, creationId: creationId, status: 'added', quantity: 1 } :
        { type: 'cdc.personalization.cart.result', protocolVersion: 1,
          requestId: requestId, status: status, errorCode: code });
    }
    async function cart() {
      var response = await fetcher(cartBase + '.js', { method: 'GET', credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('cart_unavailable');
      return response.json();
    }
    async function add(message) {
      var creationId = '00000000-0000-4000-8000-000000000000';
      var attempted = false;
      try {
        var resolvedResponse = await fetcher(engineOrigin + '/api/personalization/cart/resolve', {
          method: 'POST', credentials: 'omit', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ requestId: message.requestId, cartIntentToken: message.cartIntentToken })
        });
        if (!resolvedResponse.ok) throw new Error('cart_unavailable');
        var resolved = await resolvedResponse.json();
        if (!validLine(resolved, message.requestId)) throw new Error('cart_unavailable');
        creationId = resolved.creationId;
        var markerKey = 'cdc-engraving-cart-attempt-v1:' + creationId;
        var beforeCart = await cart();
        var before = matchingItems(beforeCart, resolved.line, creationId);
        if (before.some(function (match) { return !match.valid; })) throw new Error('cart_rejected');
        if (before.length === 1) {
          storage.removeItem(markerKey);
          await openNativeCart(win, beforeCart);
          result(message.requestId, creationId, 'added'); return;
        }
        if (storage.getItem(markerKey)) throw new Error('cart_unconfirmed');
        storage.setItem(markerKey, JSON.stringify({ requestId: message.requestId, startedAt: Date.now() }));
        attempted = true;
        var response;
        try {
          response = await fetcher(cartBase + '/add.js', { method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(resolved.line.variantId), quantity: 1,
              properties: resolved.line.properties }] }) });
        } catch (_) { response = null; }
        if (response && !response.ok) {
          storage.removeItem(markerKey);
          throw new Error('cart_rejected');
        }
        var afterCart = await cart();
        var after = matchingItems(afterCart, resolved.line, creationId);
        if (after.length === 1 && after[0].valid) {
          storage.removeItem(markerKey);
          await openNativeCart(win, afterCart);
          result(message.requestId, creationId, 'added'); return;
        }
        throw new Error('cart_unconfirmed');
      } catch (error) {
        var code = error && error.message;
        if (attempted && code !== 'cart_rejected') code = 'cart_unconfirmed';
        if (code !== 'cart_rejected' && code !== 'cart_unconfirmed') code = 'cart_unavailable';
        result(message.requestId, creationId, code === 'cart_unconfirmed' ? 'unconfirmed' : 'rejected', code);
      }
    }
    function onMessage(event) {
      if (event.origin !== engineOrigin || event.source !== frame.contentWindow) return;
      var data = event.data;
      if (exact(data, ['type', 'protocolVersion']) && data.type === 'cdc.personalization.ready' && data.protocolVersion === 1) {
        ready = true;
        context();
        if (loaded && onReady) onReady();
        return;
      }
      if (exact(data, ['type', 'protocolVersion', 'contentHeight']) && data.type === 'cdc.personalization.resize' &&
          data.protocolVersion === 1 && Number.isSafeInteger(data.contentHeight) &&
          data.contentHeight >= 360 && data.contentHeight <= 4000) {
        frame.style.height = Math.max(600, data.contentHeight) + 'px'; return;
      }
      if (validRequest(data) && !pending && !completed.has(data.requestId)) {
        pending = true;
        completed.add(data.requestId);
        Promise.resolve().then(function () { return add(data); }).finally(function () { pending = false; });
      }
    }
    win.addEventListener('message', onMessage);
    frame.addEventListener('load', onLoad);
    return { onMessage: onMessage, cart: cart, dispose: function () {
      win.removeEventListener('message', onMessage);
      frame.removeEventListener('load', onLoad);
    } };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createParentBridge: createParentBridge,
    validRequest: validRequest, validLine: validLine, matchingItems: matchingItems,
    openNativeCart: openNativeCart };
  if (scope && scope.document) {
    async function start() {
      if (scope.location.origin !== SHOP_ORIGIN) return;
      scope.document.querySelectorAll('[data-cdc-personalization-embed]').forEach(async function (element) {
        if (element.dataset.cdcMounted === 'true' || element.dataset.engineOrigin !== ENGINE_ORIGIN) return;
        var frame = element.querySelector('iframe');
        var frameSrc = frame && frame.dataset.src;
        if (!frameSrc || new URL(frameSrc).origin !== ENGINE_ORIGIN) return;
        var productId = element.dataset.productId;
        if (!/^\d+$/.test(productId)) return;
        element.dataset.cdcMounted = 'true';
        var legacy = scope.document.querySelector('[id^="cdc-slate-apero-"]');
        var productInfo = element.closest('.product-page-info');
        var active = false;
        var expired = false;
        var bridge;
        var nativeControls = [];
        scope.document.addEventListener('click', function (event) {
          if (!active || !event.target.closest) return;
          var nativeAdd = event.target.closest('[data-js-trigger-id="add-to-cart"]');
          if (nativeAdd) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
        if (productInfo) productInfo.addEventListener('submit', function (event) {
          if (active && event.target.matches('form[action*="/cart/add"]')) {
            event.preventDefault(); event.stopImmediatePropagation();
          }
        }, true);
        function setNativeControlsDisabled(disabled) {
          if (!productInfo) return;
          if (disabled) {
            productInfo.querySelectorAll('.product-page-info__button-add-to-cart button, ' +
              '.product-page-info__quantity input, .product-page-info__quantity button').forEach(function (control) {
              nativeControls.push({ control: control, wasDisabled: control.disabled });
              control.disabled = true;
            });
          } else {
            nativeControls.forEach(function (item) { item.control.disabled = item.wasDisabled; });
            nativeControls = [];
          }
        }
        async function enabled() {
          try {
            var response = await scope.fetch(ENGINE_ORIGIN + '/api/personalization/public?productId=' + productId,
              { method: 'GET', credentials: 'omit', cache: 'no-store' });
            if (!response.ok) return false;
            var result = await response.json();
            return result && result.enabled === true;
          } catch (_) { return false; }
        }
        async function atelierEnabled() {
          var controller = typeof scope.AbortController === 'function' ? new scope.AbortController() : null;
          var timer = controller ? scope.setTimeout(function () { controller.abort(); }, 3000) : 0;
          try {
            var response = await scope.fetch(ENGINE_ORIGIN + '/api/atelier/public?productId=' + productId,
              { method: 'GET', credentials: 'omit', cache: 'no-store', signal: controller ? controller.signal : undefined });
            if (!response.ok) return false;
            var result = await response.json();
            return result && result.enabled === true;
          } catch (_) { return false; }
          finally { if (timer) scope.clearTimeout(timer); }
        }
        function fallback() {
          active = false;
          setNativeControlsDisabled(false);
          if (legacy) { legacy.hidden = false; legacy.removeAttribute('aria-hidden'); }
          if (productInfo) productInfo.removeAttribute('data-cdc-engine-active');
          element.hidden = true;
          if (bridge) { bridge.dispose(); bridge = null; }
          frame.removeAttribute('src');
        }
        // Lot D (02/10/2026): the planche's Atelier first, when its own switch answers true within 3 s. Any other answer, an
        // error or a delay keeps engraving-1 exactly as before (nothing below this block changes).
        var atelier = scope.CDCAtelier && scope.document.querySelector('[data-cdc-atelier-planche][data-product-id="' + productId + '"]');
        if (atelier && await atelierEnabled()) {
          active = true;
          setNativeControlsDisabled(true);
          if (legacy) { legacy.hidden = true; legacy.setAttribute('aria-hidden', 'true'); }
          if (productInfo) productInfo.setAttribute('data-cdc-engine-active', 'true');
          atelier.hidden = false;
          scope.CDCAtelier.mount(atelier, { productId: productId, variantId: atelier.dataset.variantId, title: atelier.dataset.title });
          return;
        }
        if (!await enabled()) return;
        var timeout = scope.setTimeout(function () { expired = true; if (!active) fallback(); }, 12000);
        bridge = createParentBridge({ frame: frame, window: scope, fetch: scope.fetch.bind(scope),
          storage: scope.sessionStorage, engineOrigin: ENGINE_ORIGIN, shopOrigin: SHOP_ORIGIN,
          productId: productId, locale: element.dataset.locale, onReady: function () {
            if (expired || active) return;
            scope.clearTimeout(timeout);
            active = true;
            setNativeControlsDisabled(true);
            element.hidden = false;
            if (legacy) { legacy.hidden = true; legacy.setAttribute('aria-hidden', 'true'); }
            if (productInfo) productInfo.setAttribute('data-cdc-engine-active', 'true');
          } });
        frame.src = frameSrc;
        scope.addEventListener('focus', async function () { if (active && !await enabled()) fallback(); });
      });
    }
    if (scope.document.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})(typeof window === 'undefined' ? null : window);
